import { BIG_TEN } from "utils/bigNumber";

export const DEFAULT_TOKEN_DECIMAL = BIG_TEN.pow(18);
export const DEFAULT_GAS_LIMIT = 250000;

export * from "./constants";
